<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
                <h3 class="font-weight-bold">Revenue Office Type Wise Report</h3>
                <div class="text-xs-right">
                    <export-summary-report-button model="revenue-office-type-wise" :export-date="range"
                                         v-if="$oauth.checkIfHasPermission(['read revenue-summary-report'])"/>
                </div>
            </v-flex>
            <v-flex xs12>

                <v-card>
                    <v-layout class="py-1 mx-2" row wrap>
                        <v-flex xs6 class="d-flex align-center">
                            <custom-date-range-picker @change="updateByOffice"
                                                      v-model="range"/>
                        </v-flex>
                    </v-layout>

                    <v-divider/>
                    <v-card-text class="pa-0">
                        <v-simple-table
                                class="elevation-0 pb-6"
                                v-if="$oauth.checkIfHasPermission(['read issued-visa-summary-report'])"
                        >
                            <thead>
                            <v-overlay :value="progressLinearLoading">
                              <v-progress-circular
                                  indeterminate
                                  size="64"
                              ></v-progress-circular>
                            </v-overlay>
                            <tr>
                                <th class="text-center">S.N</th>
                                <th>Office</th>
                                <th class="text-center">Visa Fee(USD)</th>
                                <th class="text-center">Late Fee(USD)</th>
                                <th class="text-center">Penalty(USD)</th>
                                <th class="text-center">Total(USD)</th>
                            </tr>
                            </thead>

                            <tbody v-if="office_wise_data.length">
                            <tr v-for="(item,i) in office_wise_data">
                                <td class="text-center">{{i+1}}</td>
                                <td >{{item.office_type}}</td>
                                <td class="text-center">{{parseFloat(item.visa_fee)}}</td>
                                <td class="text-center">{{item.late_fee !== null ? parseFloat(item.late_fee): 0}}</td>
                                <td class="text-center">{{item.penalty_fee !== null ? parseFloat(item.penalty_fee) : 0}}</td>
                                <td class="font-weight-bold text-center">{{parseFloat(item.visa_fee) +  (item.late_fee !==  null ? parseFloat(item.late_fee) : 0) +  (item.penalty_fee !== null ? parseFloat(item.penalty_fee) : 0)}}</td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr class="text-center">
                                <td>No record found</td>
                            </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import CustomDateRangePicker from "../../components/CustomDateRangePicker";
    import {commonStoreMixin} from "../../mixins/commonStoreMixin";
    import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
    import ExportSummaryReportButton from "../../components/ExportSummaryReportButton";
    import Http from "axios";
    import {VERSIONED_API_URL} from "../../config/config";

    const REVENUE_SUMMARY_REPORT_URL = `${VERSIONED_API_URL}/summary-report/revenue-office-type-wise`;
    export default {
        name: "RevenueOfficeTypeWise",
        data() {
            return {
                office_wise_data:[],

                range:{},
            };
        },
        components: {CustomDateRangePicker, IssuedVisaFooter, ExportSummaryReportButton},
        mixins: [commonStoreMixin],
        computed: {
            ...mapGetters({
                loading: "ArrivalDepartureReport/reportLoading",
            }),
            from_main_office() {
                return this.$store.state.AuthUser.user.from_main_office;
            },
            offices(){
                return this.$store.state.OfficeList.offices;
            }
        },
        methods: {
            updateByOffice(){
                let params = {};
              this.progressLinearLoading = true;
                if(Object.keys(this.range).length > 0)
                    params.date_range = this.range;

                Http.get(REVENUE_SUMMARY_REPORT_URL, {
                    params:params
                })
                    .then((res)=>{
                        this.office_wise_data = res.data.data;
                      this.progressLinearLoading = fa;
                        // this.getData();
                    })
                    .catch(()=>{
                        this.$store.commit('Notification/showError','Something went wrong');
                      this.progressLinearLoading = false;
                    });
            }


        },
        mounted() {
          this.progressLinearLoading = true;
            Http.get(REVENUE_SUMMARY_REPORT_URL)
                .then((res)=>{
                    this.office_wise_data = res.data.data;
                  this.progressLinearLoading = false;

                })
                .catch(()=>{
                  this.progressLinearLoading = false;
                });

            this.range = {
                start: new Date().toISOString().substr(0, 10),
                end: new Date().toISOString().substr(0, 10)
            }
        }
    }
</script>
